import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { populateUserMailboxInfo, onDismissed } from '../actions/internalActions';

// Sets the value of userMailboxWrapper according to data provided by actionMessage
export const userMailboxInfoMutator = mutator(populateUserMailboxInfo, actionMessage => {
    getStore().userMailboxWrapper = actionMessage.userMailboxWrapper;
});

// Resets all values in store
export const onDismissedMutator = mutator(onDismissed, () => {
    const store = getStore();
    store.userMailboxWrapper = null;
    store.findControlViewState = {
        queryString: '',
        shouldShowFindResult: false,
        findResultSet: [],
        findResultType: FindResultType.None,
        findResultHightlightIndex: -1,
        isSearching: false,
        hasSearchedDirectory: false,
        findPeopleFeedbackManager: null,
    };
});

export { EmailAddressWrapper };
